import useTranslation from 'hooks/useTranslation'
import ArrowBtn from 'components/buttons/ArrowBtn'
import BackBtn from 'components/buttons/BackBtn'
import { getPortalRoot } from 'utils/portal'
import React, { useEffect } from 'react'
import { createPortal } from 'react-dom'
import Popup from './Popup'

export interface BlockedDatePopupAction {
  label: string
  onClick: () => void
}

export interface BlockedDatePopupProps {
  title: string
  description?: React.ReactNode
  /** glowny przycisk, np. "Przedluz wynajem"; brak = tylko "Wroc" */
  action?: BlockedDatePopupAction
  backLabel?: string
  close: () => void
}

const stop = (e: React.SyntheticEvent) => e.stopPropagation()

/**
 * Modal po kliknieciu daty spoza dozwolonego zakresu kalendarza (patrz SoftLimitCalendar).
 * Renderowany przez portal, bo kalendarz czesto siedzi w innym popupie (transformacje, overflow).
 */
const BlockedDatePopup: React.FC<BlockedDatePopupProps> = ({ title, description, action, backLabel, close }) => {
  const { t } = useTranslation('basic.blockedDate')

  // ESC zamyka tylko ten modal, nie popup kalendarza pod spodem
  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key !== 'Escape' && e.keyCode !== 27) return
      e.stopImmediatePropagation()
      close()
    }
    window.addEventListener('keydown', onKeyDown, true)
    return () => window.removeEventListener('keydown', onKeyDown, true)
  }, [close])

  return createPortal(
    // zdarzenia z portalu babelkuja drzewem Reacta do popupu kalendarza:
    // klik bylby uznany za "klik poza popupem", a przeciagniecie za gest zamkniecia/zmiany miesiaca
    <div onClick={stop} onTouchStart={stop}>
      <Popup
        isPopup
        centered
        close={close}>
        <div className='blockedDate__popup'>
          <div className='popup__title'>
            <i className='icon icon--logo' />
            <div>{title}</div>
            {description && <div>{description}</div>}
          </div>
          <div className='blockedDate__buttons'>
            {action && <ArrowBtn
              enlarged
              showArrow={false}
              text={action.label}
              action={action.onClick}
            />}
            <BackBtn
              text={backLabel || t('back')}
              action={close}
            />
          </div>
        </div>
      </Popup>
    </div>,
    getPortalRoot()
  )
}

export default BlockedDatePopup
